import { themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import { animationTransition } from '@utils/animationTransition';
import { styled } from '@styledComponents';
import { CTALink } from '@components/CTALink';
import { Columns } from '@components/Columns';
import { variant } from 'styled-system';

export const FooterHeroMenuItem = styled.div`
  // This is not a joykit typography so leaving it here
  a {
    font-family: Austin News Headline Web;
    font-style: normal;
    font-weight: 300;
    font-size: 48px;
    line-height: 64px;
    letter-spacing: -0.015em;
    white-space: nowrap;
    @media screen and (min-width: ${props => props.theme.breakpoints[1]}) {
      font-size: 72px;
      line-height: 93px;
    }
    ${themeMediaQuery('below_sm')} {
      font-size: 36px;
      line-height: 64px;
    }
  }
`;

export const FooterSubHeroHeader = styled.div.attrs({ typography: 'sectionEyeBrow24' })`
  ${variant({
    prop: 'typography',
    scale: 'typography',
  })};
  margin-bottom: 14px;

  color: ${themeColor('linkFooterDefault')};
`;

export const FooterSubHeroItem = styled.div`
  ${CTALink} {
    line-height: 25px;
    font-size: 24px !important;
  }
  margin-bottom: 28px;

  ${themeMediaQuery('below_sm')} {
    ${CTALink} {
      line-height: 36px;
    }
    margin-bottom: 32px;
  }
`;

export const FooterSubHeroItems = styled.div<{ isTermsAndCondMarginBottom?: boolean }>`
  ${CTALink} {
    line-height: 8px;
  }
  margin-bottom: ${({ isTermsAndCondMarginBottom }) => (isTermsAndCondMarginBottom ? '64px' : '15px')};

  ${themeMediaQuery('below_sm')} {
    ${CTALink} {
      line-height: 18px;
    }
    margin-bottom: 36px;
  }
`;

export const SocialMediaMenuList = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 12px;
  svg {
    :hover {
      color: ${themeColor('purple3')};
    }
    transition: ${animationTransition('color')};
  }
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const FooterColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    margin-left: 0px;
    margin-right: 0px;
  }
`;

export const FooterColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 0px;
    padding-right: 0px;
  }
`;
